import React from 'react';
import { Cropper, UnsafeHTML, TypographyStyler } from '@honeycomb/ui-core';
import { useGlobalContext } from '@honeycomb/data';
import { useGenericRootComponent } from './GenericRootComponent/GenericRootComponent.context';
export function IntroText({ text: bodyText }) {
    const { resourceStrings: { HC_READ_MORE, HC_READ_LESS }, } = useGlobalContext();
    const { backgroundColor, textColor } = useGenericRootComponent();
    return (React.createElement(Cropper, { maxHeight: 108, contentBackgroundColor: backgroundColor || 'background.body', ButtonProps: { color: textColor !== null && textColor !== void 0 ? textColor : 'text.link', weight: 'semiBold' }, buttonCaption: { cropped: HC_READ_MORE, expanded: HC_READ_LESS } },
        React.createElement(TypographyStyler, { component: "div", ta: "justify", tal: "center", c: textColor, headingColor: "inherit", anchorColor: "inherit" },
            React.createElement(UnsafeHTML, null, bodyText))));
}
